import styled from 'styled-components';

export const Adicional = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  border: none;
  background-color: #fff;
  font-size: 16px;
  padding: 12px;
  border-radius: 5px;

  &:hover {
    background-color: #2c73e9;
    color: #fff;
  }
`;
